export default {
    PLUS_ITEM:"PLUS_ITEM",
    MILUS_ITEM:"MILUS_ITEM",
    NULL_ITEM:"NULL_ITEM",
    SET_CELL_LIST:"SET_CELL_LIST",
    SET_LOGIN:"SET_LOGIN",
    SET_LOGOUT:"SET_LOGOUT",
    SET_USER_NAME:"SET_USER_NAME"
}